import React from "react";
import { MapPin } from "lucide-react";
import { useInView } from "../../hooks/use-in-view";

const regions = [
  { state: "Gujarat — Mainland", cities: ["Vapi", "Ankleshwar", "Vadodara", "Ahmedabad", "Surat", "Bharuch", "Valsad", "Sarigam", "Umargam", "Daman", "Silvassa"] },
  { state: "Gujarat — Saurashtra & Kutch", cities: ["Rajkot", "Jamnagar", "Bhavnagar", "Junagadh", "Porbandar", "Morbi", "Gondal", "Veraval", "Surendranagar", "Amreli", "Bhuj", "Mundra"] },
  { state: "Maharashtra", cities: ["Mumbai", "Thane", "Boisar", "Tarapur", "Pune", "Mahad", "Roha", "Kolhapur", "Satara", "Sambhajinagar", "Jalgaon", "Akola", "Nashik", "Nagpur", "Solapur"] },
  { state: "Madhya Pradesh", cities: ["Indore", "Bhopal", "Pithampur", "Ratlam", "Dewas", "Jabalpur", "Rewa", "Nagda", "Ujjain", "Gwalior"] },
  { state: "Rajasthan", cities: ["Jaipur", "Bhilwara", "Udaipur", "Jodhpur", "Kota", "Ajmer", "Alwar", "Bikaner", "Pali", "Sikar"] },
  { state: "Punjab & Haryana", cities: ["Ludhiana", "Amritsar", "Jalandhar", "Patiala", "Bathinda", "Mohali", "Ambala", "Karnal", "Hisar", "Sonipat", "Rohtak", "Yamuna Nagar", "Panipat"] },
  { state: "Jharkhand & Chhattisgarh", cities: ["Ranchi", "Jamshedpur", "Bokaro", "Dhanbad", "Hazaribagh", "Raipur", "Bhilai", "Bilaspur", "Korba", "Durg"] },
  { state: "Delhi NCR", cities: ["Delhi", "Gurgaon", "Faridabad", "Noida", "Ghaziabad", "Manesar"] },
  { state: "South India", cities: ["Hyderabad", "Chennai", "Bengaluru", "Coimbatore", "Vijayawada", "Visakhapatnam"] },
  { state: "East India", cities: ["Kolkata", "Howrah", "Bhubaneswar", "Cuttack", "Rourkela", "Asansol"] }
];

const ServiceAreas = () => {
  const [ref, inView] = useInView();
  return (
    <section id="areas" className="py-20 lg:py-28 bg-slate-50 relative">
      <div className="absolute inset-0 bg-grid opacity-30 pointer-events-none" />
      <div className="relative max-w-7xl mx-auto px-5 lg:px-6">
        <div className="max-w-3xl">
          <div className="text-[12px] uppercase tracking-[0.22em] font-semibold text-teal-700">Service Areas</div>
          <h2 className="mt-3 font-display font-extrabold text-slate-900 text-[34px] lg:text-[46px] leading-[1.08]">
            Pan-India delivery, <span className="text-gradient-anim">single point of contact</span>
          </h2>
          <p className="mt-4 text-slate-600 text-[16px] leading-relaxed">
            From our Vapi GIDC plant, we dispatch FRP drums, HDPE carboys, IBCs and full-tanker loads across 15+ Indian states &mdash; from the Saurashtra coast to Punjab, and from Jharkhand's steel belt to South India. Below are the major industrial corridors we serve.
          </p>
        </div>

        <div ref={ref} className="mt-12 grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {regions.map((r, i) => (
            <div
              key={r.state}
              className={`reveal ${inView ? "is-visible" : ""} bg-white rounded-2xl border border-slate-200 p-5 card-lift`}
              style={{ transitionDelay: `${i * 70}ms` }}
            >
              <div className="flex items-center gap-3">
                <div className="h-10 w-10 rounded-lg bg-teal-50 border border-teal-100 flex items-center justify-center">
                  <MapPin className="h-5 w-5 text-teal-700" />
                </div>
                <h3 className="font-display font-bold text-[16px] text-slate-900">{r.state}</h3>
              </div>
              <div className="mt-4 flex flex-wrap gap-1.5">
                {r.cities.map((c) => (
                  <span key={c} className="px-2 py-0.5 rounded-md bg-slate-100 border border-slate-200 text-slate-700 text-[11.5px] font-medium">{c}</span>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServiceAreas;
